import { useState } from 'react';
import { testSendBookingNotification, sendBookingNotification } from '../../services/telegram-notifications';

const TestNotificationsPage = () => {
  const [isSending, setIsSending] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [chatId, setChatId] = useState('-1002515525241');
  const [error, setError] = useState<string | null>(null);
  const [bookingId, setBookingId] = useState('');

  const handleSendTestNotification = async () => {
    setIsSending(true);
    setResult(null);
    setError(null);
    
    // Проверка формата ID чата
    if (!/^-?\d+$/.test(chatId)) {
      setError('Неверный формат ID чата. ID должен быть числом или начинаться с - для группового чата.');
      setIsSending(false);
      return;
    }
    
    try {
      const success = await testSendBookingNotification(chatId);
      setResult(success ? 'Тестовое уведомление успешно отправлено!' : 'Ошибка при отправке уведомления. Проверьте консоль браузера для подробностей.');
    } catch (error) {
      console.error('Ошибка при тестировании уведомлений:', error);
      setResult(`Ошибка: ${error instanceof Error ? error.message : 'Неизвестная ошибка'}`);
    } finally {
      setIsSending(false);
    }
  };
  
  const handleSendBookingNotification = async () => {
    if (!bookingId) {
      setError('Необходимо указать ID бронирования');
      return;
    }
    
    setIsSending(true);
    setResult(null);
    setError(null);
    
    try {
      const success = await sendBookingNotification(bookingId);
      setResult(success 
        ? `Уведомление о бронировании ${bookingId} успешно отправлено!` 
        : `Ошибка при отправке уведомления о бронировании ${bookingId}. Проверьте консоль браузера для подробностей.`);
    } catch (error) {
      console.error('Ошибка при отправке уведомления о бронировании:', error);
      setResult(`Ошибка: ${error instanceof Error ? error.message : 'Неизвестная ошибка'}`);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Тестирование уведомлений Telegram</h1>
      
      <div className="mb-6">
        <label htmlFor="chatId" className="block text-sm font-medium mb-2">
          ID чата Telegram
        </label>
        <input
          type="text"
          id="chatId"
          value={chatId}
          onChange={(e) => setChatId(e.target.value)}
          className={`w-full p-2 border rounded ${error ? 'border-red-500' : ''}`}
          placeholder="Введите ID чата Telegram"
        />
        {error ? (
          <p className="text-sm text-red-500 mt-1">{error}</p>
        ) : (
          <p className="text-sm text-gray-500 mt-1">
            ID чата должен быть числом (персональный чат) или начинаться с - для группового чата (например, -1002515525241).
          </p>
        )}
      </div>
      
      <div className="mb-6">
        <button
          onClick={handleSendTestNotification}
          disabled={isSending}
          className={`px-4 py-2 rounded text-white ${
            isSending ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {isSending ? 'Отправка...' : 'Отправить тестовое уведомление'}
        </button>
      </div>
      
      <div className="border-t pt-6 mt-6">
        <h2 className="text-xl font-semibold mb-4">Тестирование по ID бронирования</h2>
        
        <div className="mb-4">
          <label htmlFor="bookingId" className="block text-sm font-medium mb-2">
            ID бронирования
          </label>
          <input
            type="text"
            id="bookingId"
            value={bookingId}
            onChange={(e) => setBookingId(e.target.value)}
            className="w-full p-2 border rounded"
            placeholder="Введите ID существующего бронирования"
          />
        </div>
        
        <div className="mb-6">
          <button
            onClick={handleSendBookingNotification}
            disabled={isSending || !bookingId}
            className={`px-4 py-2 rounded text-white ${
              isSending || !bookingId ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            {isSending ? 'Отправка...' : 'Отправить уведомление о бронировании'}
          </button>
        </div>
      </div>
      
      {result && (
        <div className={`p-4 rounded ${result.includes('успешно') ? 'bg-green-100' : 'bg-red-100'}`}>
          {result}
        </div>
      )}
      
      <div className="mt-8 p-4 border rounded bg-gray-50">
        <h2 className="text-lg font-semibold mb-2">Информация</h2>
        <p>
          Эта страница предназначена для тестирования функции отправки уведомлений в Telegram.
          Будет отправлено тестовое сообщение с примером уведомления о бронировании.
        </p>
        <p className="mt-2">
          Для использования настоящих уведомлений о бронировании необходимо создать новое бронирование
          через основной функционал приложения или указать ID существующего бронирования в форме выше.
        </p>
        <div className="mt-4">
          <h3 className="font-medium text-base">Возможные проблемы:</h3>
          <ul className="list-disc ml-5 text-sm mt-2">
            <li>Убедитесь, что бот @franema_rental_bot добавлен в чат</li>
            <li>Проверьте правильность ID чата</li>
            <li>Бот должен иметь права на отправку сообщений в чат</li>
            <li>Токен бота должен быть корректным в .env файле (VITE_TELEGRAM_BOT_TOKEN)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestNotificationsPage; 